module.exports = __webpack_public_path__ + "store-icon.e8f7cb7a5665794412b8c61430193f59.svg";